import { AreaDto } from '../core-data/doc/area-dto';
import { CertificateDto } from './certificate-dto';
import { DocumentDto } from './document-dto';
import { ImageDto } from './image-dto';

export class PackagingPartBaseData {
    creationTimestamp!: Date;
    lastModificationTimestamp!: Date;
    associatedTagIdentifiers: number[] = [];
    directoryId!: number;
    directoryName?: string;
    isRecyclabilityRelevant!: boolean;
    isCCRelevant!: boolean;
    isLCARelevant!: boolean;
    images: ImageDto[] = [];
    documents: DocumentDto[] = [];
    certificates: CertificateDto[] = [];
    hasExternalTracking?: boolean;
    isCurrentVersion = false;
    version!: number;
    versionName?: string;
    docArea: AreaDto = new AreaDto();

}
